export default __webpack_public_path__ + "static/media/Rpn.8ca1d017.jpg";